module.exports = __webpack_public_path__ + "static/media/Marotte_Tulipier_Endron_MT108-25-Scale.93872018.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/Marotte_Tulipier_Endron_MT108-25-Scale.jpg
// module id = 962
// module chunks = 37